import './styles/SearchFeedRetry.css';

export default function SearchFeedRetry({ error, onRetry }) {
  if (!error || !onRetry) return null;

  return (
    <div className="home-search-feed__retry">
      <p>{error}</p>
      <button type="button" onClick={onRetry}>Try again</button>
    </div>
  );
}
